// Imports
import React, { useRef } from 'react';
import { UnverifiedBankAccount } from '.';
import Modal from '../../../../../../shareables/front-end/modal';


// Define the accepted props
interface Props {
	microdeposit?: UnverifiedBankAccount['verification']['microdeposit'];
}


// Function component
const MicrodepositInfoModal: React.FC<Props> = ({ microdeposit }) => {
	// Use ref
	const lastDefinedMicrodeposit = useRef(microdeposit);
	
	
	// Track last value so content doesn't change while the modal animates closed
	if (microdeposit !== undefined) {
		lastDefinedMicrodeposit.current = microdeposit;
	}
	
	
	// Return JSX
	return (
		<Modal identifier='microdeposit-info' title='About microdeposits'>
			{lastDefinedMicrodeposit.current === 'code' ? (
				<p>
					After a bank account is added, it must be verified via a 1¢ microdeposit with a random code in its descriptor.
					This microdeposit may take a few days to show up; once it does, return to this page to confirm the code and
					complete verification.
				</p>
			) : (
				<p>
					After a bank account is added, it must be verified via two small microdeposits with random amounts less than
					$1. These microdeposits may take a few days to show up; once they do, return to this page to confirm the two
					correct amounts and complete verification.
				</p>
			)}
		</Modal>
	);
};

export default MicrodepositInfoModal;
